<template>
    <div class="top flex" :class="shift?'topDing':''">
      <div class="navLeft flex">
        <span class="flex-cc"><img src="static/img/logo_1@2x.png" alt=""></span>
        <span class="hotline flex-c"><em>服务热线</em><em>4000-520-887</em></span>
      </div>
      <div class="navList flex-cc">
        <span @click="openHome('http://www.gzzjd.com')">织金洞首页</span>
        <span @click="goRoute('/')">商城首页</span>
        <span @click="goRoute('/destination')">目的地</span>
        <span @click="goRoute('/ticket')">门票预订</span>
        <span @click="goRoute('/explanation')">讲解预订</span>
        <span @click="goRoute('/travelNotes')">游记攻略</span>
        <span @click="goRoute('/hotel')">酒店预订</span>
        <span @click="goRoute('/restaurant')">餐饮美食</span>
        <span @click="goRoute('/specialProduct')">特产商城</span>
        <span @click="goRoute('/user/orderManage?type=0')">我的订单</span>
      </div>
      <div class="loginBox flex-ac" v-if="token">
        <span @click="goRoute('/user')">{{userInfo.nickName||userInfo.userName}}</span>
        <span @click="loginOut">退出登录</span>
      </div>
      <div class="loginBox flex-ac" v-else>
        <span @click="goRoute('/register')">注册</span>
        <span @click="goRoute('/login')">登录</span>
      </div>
      
    </div>
</template>

<script>
export default {
  name: 'top',
  data () {
    return {
      dialogVisible:false,
    }
  },
  props:{
    shift:{
      default:false,
      type:Boolean
    }
  },
  computed:{
    userInfo:{
      get(){
        return this.$store.state.userInfo||JSON.parse(this.local_getItem("user")||'{}')||{}
      },
      set(){}
    },
    token:{
      get(){
        return this.$store.state.token||this.local_getItem('token')||''
      },
      set(){}
    }
  },
  watch:{

  },
  activated(){

  },
  deactivated(){

  },
  created(){

  },
  mounted(){
    
  },
  methods:{
    loginOut(){// 退出登录
      var that=this;
      that.$store.commit('setUserInfo','');
      that.token='';
      that.userInfo='';
      that.$message({
          message:'退出登录成功！',
          type: "success",
          duration:1000
        });
      that.goRoute('/');
    },
    openHome(url){
      window.open(url)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.top.topDing{position: fixed;top: 0;left: 0;width: calc(100% - 40px);z-index:6;}
.top{
  padding: 0 20px;background:#000;color:#fff;
  
  .navLeft span{img{width: auto;height: 52px;}}
  .navLeft .hotline{
    font-size: 14px;line-height: 34px;padding-left:54px;
    & em:last-child{font-size: 20px;line-height: 36px;color:#FFB507;}
  }
  .navList{
    font-size: 14px;flex:1;
    span{width: 104px;display: flex;justify-content: center;align-items: center;cursor: pointer;}
  }
  .loginBox{
    font-size: 14px;
    span{display: flex;justify-content: center;align-items: center;cursor: pointer;padding:0 10px;position: relative;
    &:first-child::after{content: "";position: absolute;top: 50%;right: 0;transform: translateY(-50%);width: 1px;height: 16px;background: #fff;}
    &:first-child{max-width: 80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;display: inline-block;}
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue